export default function (flow, group, identifier, document) {
  let stack = []
  let path = []
  if (group === 'review') return path
  stack.push(`${group}.${identifier}`)
  path.push(`${group}.${identifier}`)
  while (stack.length > 0) {
    let [sg, si] = stack.pop().split('.')
    let c = flow[sg]?.[si]
    if (!c) continue
    if (c.next) {
      const nn = typeof c.next === 'function' ? c.next(document) : c.next
      if (nn !== 'review') {
        path.push(nn)
      }
      stack.push(nn)
    } else if (c.list) {
      c.list.forEach(l => {
        const hasValue = document.data.get(sg)?.get(si)
        const nextValue = typeof l.next === 'function' ? l.next(document) : l.next
        if (!hasValue || hasValue === l.value) {
          path.push(nextValue)
        }
        if (!hasValue || hasValue === l.value) {
          stack.push(nextValue)
        }
      })
    }
  }
  return path
}
